import { render, staticRenderFns } from "./Fossils.vue?vue&type=template&id=60e3fd37&"
import script from "./Fossils.vue?vue&type=script&lang=js&"
export * from "./Fossils.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports